export default __webpack_public_path__ + "static/media/reference_link.fd7cf005.svg";